<script>

import { Vue3Lottie } from 'vue3-lottie'
import LoadingPic from "../../assets/json/LoadingPic.json"

export default {
  name:'LoadingPic',
  components: {
    Vue3Lottie,
  },

  setup(){

    return{

      LoadingPic

    }
  }
}

</script>

<template>

  <Vue3Lottie class="loading_pic" :animationData="LoadingPic" :height="100" :width="100" />
<!--  <div class="loading_pic">loading</div>-->

</template>

<style scoped>


</style>